import React, { useState, useEffect, useMemo } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SubCardCollapase from 'ui-component/cards/SubCardCollapase';
import { BigPlayButton, Player } from 'video-react';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import PersonIcon from '@mui/icons-material/Person';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';

import ServiciosCatalogo from '../Components/services';

// ==============================|| DEFAULT DASHBOARD ||============================== //

const useStyles = makeStyles((theme) => ({
    curso: {
        backgroundColor: theme.palette.secondary[800]
    },
    grupo: {
        borderRadius: '8px',
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.secondary[800]
    }
}));

const ItemCorreo = ({ email, etiqueta }) => {
    return (
        <span>
            <h4 style={{ display: 'flex', alignItems: 'flex-start' }}>
                <ForwardToInboxIcon fontSize="small" /> Correo: &nbsp;
                <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`} target="_blank" rel="noreferrer">
                    {email}
                </a>
                {etiqueta && <span style={{ marginLeft: '8px', fontWeight: 400, fontSize: '0.8rem', color: '#757575' }}>({etiqueta})</span>}
            </h4>
        </span>
    );
};

const Contacto = ({ infoCotac, tipoCurso, correoCurso }) => {
    const classes = useStyles();
    const services = ServiciosCatalogo();
    const [correos, setCorreos] = useState([]);

    const idDepto = useMemo(() => {
        const valor = infoCotac?.depto ?? infoCotac?.departamento ?? null;
        const num = Number(valor);
        return Number.isFinite(num) && num > 0 ? num : 0;
    }, [infoCotac]);

    useEffect(() => {
        let activo = true;

        services.buscaCorreosDepto(
            (res) => {
                if (!activo) return;
                setCorreos(Array.isArray(res?.data) ? res.data : []);
            },
            { idDepto }
        );

        return () => {
            activo = false;
        };
    }, [idDepto, tipoCurso]);

    // Unimos el correo propio del curso con los del departamento / generales, sin duplicar.
    const lista = useMemo(() => {
        const arr = Array.isArray(correos) ? [...correos] : [];

        const yaExiste = (correo) => arr.some((x) => String(x?.correo || '').toLowerCase() === String(correo).toLowerCase());

        if (correoCurso && String(correoCurso).trim() !== '' && !yaExiste(correoCurso)) {
            arr.unshift({
                idCorreo: 'curso',
                correo: String(correoCurso).trim(),
                ids: null,
                nombres: 'CURSO'
            });
        }

        return arr;
    }, [correos, correoCurso]);

    return (
        <Grid container spacing={5}>
            <Grid item xs={12}>
                <ul>
                    <span>
                        <h2
                            style={{
                                backgroundColor: '#0D47A1',
                                color: '#FFFFFF',
                                borderRadius: '5px',
                                padding: '10px',
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <PersonIcon fontSize="medium" /> Contacto
                        </h2>
                    </span>

                    {lista.length > 0 ? (
                        lista.map((item) => <ItemCorreo key={`correo-${item.idCorreo}`} email={item.correo} etiqueta={item.nombres} />)
                    ) : (
                        <h4 style={{ color: '#757575', fontWeight: 400 }}>Sin correos de contacto configurados.</h4>
                    )}
                </ul>
            </Grid>
        </Grid>
    );
};

export default Contacto;
